import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "id", "value", "isDisabled", "hasError", "onChange", "onBlur", "isRequired", "options", "name"];
import React, { useCallback } from 'react';
import { Flex, FlexItem } from '../';
import { Radio } from './Radio';
import { appendHtmlClass } from '../../js/util';
import withValidation from '../Form/validation';
import './_index.scss';
var RadioGroupMemo = /*#__PURE__*/React.memo(function RadioGroup(_ref) {
  var className = _ref.className,
    id = _ref.id,
    value = _ref.value,
    isDisabled = _ref.isDisabled,
    hasError = _ref.hasError,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    isRequired = _ref.isRequired,
    options = _ref.options,
    name = _ref.name,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var newClassName = appendHtmlClass('radio-group', className);
  var newId = typeof id === 'string' ? id : 'rg-';
  var onRadioChange = useCallback(function (value, event) {
    if (value !== false && typeof onChange === 'function') onChange(value, event);
  }, [onChange]);
  var onRadioBlur = useCallback(function (value, event) {
    if (typeof onBlur === 'function') onBlur(value, event);
  }, [onBlur]);
  return /*#__PURE__*/React.createElement(Flex, Object.assign({
    as: "ul",
    className: newClassName,
    id: id,
    wrap: "wrap"
  }, rest), options.map(function (i) {
    return /*#__PURE__*/React.createElement(FlexItem, {
      as: "li",
      key: i.id
    }, /*#__PURE__*/React.createElement(Radio, {
      name: name,
      data: i.id,
      value: value === i.id ? value : false,
      id: "" + newId + i.id,
      isDisabled: isDisabled,
      hasError: hasError,
      isRequired: isRequired,
      onChange: onRadioChange,
      onBlur: onRadioBlur
    }, i.label));
  }));
});
RadioGroupMemo.defaultProps = {
  value: false,
  isDisabled: false,
  hasError: false,
  isRequired: false
};
export default withValidation(RadioGroupMemo);